import React from 'react';
import logo from './logo.svg';
import './App.css';
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import Home from './components/Home';
import Scheduler from './components/Scheduler';
import Others from './components/Others';


function App() {
  return (
    <Router>
      <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/:scheduler?" component={Scheduler} />
          <Route path="/others/:scheduler" component={Others} />
      </Switch>
    </Router>


  );
}

export default App;
